import { Search, X } from 'lucide-react'

import { cn } from '../../utils/cn'
import { Button } from './button'
import { Input } from './input'

export interface SearchInputProps extends Omit<React.ComponentProps<'input'>, 'value' | 'onChange' | 'size'> {
  value: string
  onValueChange: (value: string) => void
  /** Field height, matching `<Input>`. */
  size?: 'default' | 'sm' | 'lg'
  /** Wrapper class; use it to size the field (defaults to a 320px max). */
  className?: string
}

/** Text input with a leading magnifier and a clear button once it has a value. */
export function SearchInput({ value, onValueChange, className, ...props }: SearchInputProps) {
  return (
    <div className={cn('relative w-full max-w-xs', className)}>
      <Search className="text-muted-foreground absolute top-1/2 left-3 size-4 -translate-y-1/2" />
      <Input
        type="search"
        value={value}
        onChange={(event) => onValueChange(event.target.value)}
        className="pr-9 pl-9 text-sm [&::-webkit-search-cancel-button]:appearance-none"
        {...props}
      />
      {!!value && (
        <Button
          variant="iconOnly"
          size="icon-sm"
          aria-label="Clear search"
          className="text-muted-foreground hover:text-foreground absolute top-1/2 right-1 -translate-y-1/2"
          onClick={() => onValueChange('')}
        >
          <X />
        </Button>
      )}
    </div>
  )
}
